module.exports = __webpack_public_path__ + "static/media/voice.2dd9ff21.svg";